import React, { useState } from 'react';
import './ContactForm.css';

interface ContactFormProps {
  isOpen: boolean;
  onClose: () => void;
  /** 官网等深色页用 dark；默认 light（如登录页） */
  variant?: 'light' | 'dark';
}

const ContactForm: React.FC<ContactFormProps> = ({ isOpen, onClose, variant = 'light' }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // 这里可以添加实际的表单提交逻辑
      // 比如发送到后端API或邮件服务
      console.log('表单数据:', formData);
      
      // 模拟提交延迟
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      setSubmitStatus('success');
      
      // 3秒后关闭弹窗
      setTimeout(() => {
        onClose();
        setSubmitStatus('idle');
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          message: ''
        });
      }, 3000);
      
    } catch (error) {
      setSubmitStatus('error');
      console.error('提交失败:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    if (!isSubmitting) {
      onClose();
      setSubmitStatus('idle');
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        message: ''
      });
    }
  };

  if (!isOpen) return null;

  const rootMod = variant === 'dark' ? ' contact-modal-root--dark' : '';

  return (
    <div className={`contact-modal-overlay${rootMod}`} onClick={handleClose}>
      <div className={`contact-modal${rootMod}`} onClick={(e) => e.stopPropagation()}>
        <div className="contact-modal-header">
          <h2 className="contact-modal-title">联系我们</h2>
          <button 
            className="contact-modal-close" 
            onClick={handleClose}
            disabled={isSubmitting}
          >
            ×
          </button>
        </div>
        
        <div className="contact-modal-content">
          {submitStatus === 'success' ? (
            <div className="contact-success">
              <div className="success-icon">✓</div>
              <h3>提交成功！</h3>
              <p>我们会尽快与您联系，感谢您的关注。</p>
            </div>
          ) : submitStatus === 'error' ? (
            <div className="contact-error">
              <div className="error-icon">✗</div>
              <h3>提交失败</h3>
              <p>请稍后重试或直接通过其他方式联系我们。</p>
              <button className="retry-button" onClick={() => setSubmitStatus('idle')}>
                重试
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">姓名 *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  placeholder="请输入您的姓名"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">邮箱 *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  placeholder="请输入您的邮箱地址"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="phone">电话</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="请输入您的电话号码"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="company">公司/机构</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleInputChange}
                  placeholder="请输入您的公司或机构名称"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message">留言 *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  rows={4}
                  placeholder="请描述您的需求或问题..."
                />
              </div>
              
              <div className="form-actions">
                <button 
                  type="button" 
                  className="cancel-button" 
                  onClick={handleClose}
                  disabled={isSubmitting}
                >
                  取消
                </button>
                <button 
                  type="submit" 
                  className="submit-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? '提交中...' : '提交'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
